import { render, staticRenderFns } from "./FloatingCart.vue?vue&type=template&id=47b6d7e4&scoped=true"
import script from "./FloatingCart.vue?vue&type=script&lang=js"
export * from "./FloatingCart.vue?vue&type=script&lang=js"
import style0 from "./FloatingCart.vue?vue&type=style&index=0&id=47b6d7e4&prod&lang=scss"
import style1 from "./FloatingCart.vue?vue&type=style&index=1&id=47b6d7e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6d7e4",
  null
  
)

export default component.exports